import Swiper, { Navigation, Pagination, Thumbs } from 'swiper/core';

(function () {
  Swiper.use([Navigation, Pagination, Thumbs]);
  const styles = getComputedStyle(document.documentElement);
  const spaceBetween = parseInt(styles.getPropertyValue('--spaceSmall'), 10);

  const loopedSlides = 4;

  const galleryThumbs = new Swiper('.product-gallery__thumbnails', {
    slidesPerView: 'auto',
    spaceBetween,
    freeMode: true,
    loopedSlides, // looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  new Swiper('.product-gallery__main', {
    slidesPerView: 1,
    spaceBetween,
    loopedSlides, // looped slides should be the same
    watchOverflow: true,
    navigation: {
      nextEl: '.product-gallery__next',
      prevEl: '.product-gallery__prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
    pagination: {
      el: '.product-gallery__pagination',
      type: 'fraction',
    },
  });
})();
